<template>
    <div class="table-container">
        <div class="row">
            <div class="col-md-2">
                <label class="form-label" for="startDate">填單日期(起)</label>
                <input class="form-control" type="date" id="startDate" v-model="startDate" />
            </div>

            <div class="col-md-2">
                <label class="form-label" for="endDate">填單日期(迄)</label>
                <input class="form-control" type="date" id="endDate" v-model="endDate" />
            </div>

            <div class="col-md-2" v-if="systemName != 'recommend'">
                <label class="form-label" for="habitstage">選擇階段</label>
                <select class="form-control" id="habitstage" v-model="habitstageValue">
                    <option value=""></option>
                    <option value="思考期">思考期</option>
                    <option value="準備期">準備期</option>
                    <option value="行動期">行動期</option>
                    <option value="維持期">維持期</option>
                    <option value="思考前期">思考前期</option>
                </select>
            </div>

            <div class="col-md-2" v-if="systemName != 'recommend'">
                <label class="form-label" for="intensity">選擇強度</label>
                <select class="form-control" id="intensity" v-model="intensity">
                    <option value=""></option>
                    <option value="輕">輕</option>
                    <option value="中">中</option>
                    <option value="重">重</option>
                </select>
            </div>

            <!-- <div class="col-md-2">
                <label class="form-label" for="sportType">選擇調查類型</label>
                <select class="form-control" id="sportType" v-model="sportType">
                    <option value=""></option>
                    <option value="運動行為調查">運動行為調查</option>
                    <option value="運動項目推薦">運動項目推薦</option>
                </select>
            </div> -->

            <div class="col-md-2">
                <button @click="submitQuery" class="btn btn-primary btn-sm" style="margin-top: 35px;">查詢</button>
                <button @click="downloadExcel" class="btn btn-primary btn-sm" style="margin-top: 35px;margin-left: 15px;">下載 Excel</button>
            </div>
        </div>
        <hr>
        <!-- @click-row="handleRowClick" -->
        <EasyDataTable v-if="systemName != 'recommend'" table-class-name="customize-table" buttons-pagination
            :headers="tableColumns" :items="tableData">
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <button @click="handleRowClick(item)" class="btn btn-primary btn-sm">進入</button>
                </div>
            </template>
        </EasyDataTable>
        <EasyDataTable v-else table-class-name="customize-table" buttons-pagination :headers="tableColumns_recommend"
            :items="tableData">
            <template #item-operation="item">
                <div class="operation-wrapper">
                    <button @click="handleRowClick(item)" class="btn btn-primary btn-sm">進入</button>
                </div>
            </template>
        </EasyDataTable>
    </div>
</template>
  
<script>
import axios from 'axios'
import liff from "@line/liff";
import { useStore } from '../store/main';

export default {
    setup() {
		const store = useStore();

		return {
			store,
		};
	},
    data() {
        return {
            systemName: window.VUE_APP_System, //recommend //behavior
            isDev: window.VUE_APP_Dev,
            myLiffId: '2002453323-20Lo31Kp',
            lineLoginChannelID: '2002453323', // Replace this with your Line Login Channel ID
            accountValid: true,
            userLoginType:'',
            userToken: '',
            userCode: '',
            userRole: '',
            startDate: '',
            endDate: '',
            habitstageValue: '',
            intensity: '',
            sportType: '',
            userAccount: '',
            tableData: [],
            tableColumns: [
                // { text: "問卷類型", value: "sportType" },
                { text: "填單日期", value: "answerDate" },
                // { text: "填單者編號", value: "userid" },
                { text: "填單者", value: "name" },
                // { text: "登入口", value: "user_login_type" },
                { text: "強度", value: "intensity" },
                { text: "階段", value: "habitstageValue" },
                { text: "", value: "operation" },

            ],
            tableColumns_recommend: [
                // { text: "問卷類型", value: "sportType" },
                { text: "填單日期", value: "answerDate" },
                { text: "填單者", value: "name" },
                // { text: "登入口", value: "user_login_type" },
                { text: "運動建議", value: "activity" },
                { text: "", value: "operation" },

            ],
        }
    },
    beforeMount() {
        if (this.isDev == '1') {
            this.getListing();
        }else {
            this.userLoginType = localStorage.getItem("userLoginType");
            let lineResult = localStorage.getItem("LIFF_STORE:2002453323-20Lo31Kp:decodedIDToken");
            if (this.systemName == "recommend") {
                lineResult = localStorage.getItem("LIFF_STORE:2002453331-wK4xYK9O:decodedIDToken");
            }
            if (!lineResult && !this.userLoginType) {
                this.$router.push({ name: "LoginPage" });
            }else {
                this.getLineUserID();
            }
        }
    },
    mounted() {
        this.systemName = window.VUE_APP_System;
        if (this.systemName == "recommend") {
            //運動建議
            this.sportType = '運動項目推薦'
        } else {
            //運動行為
            this.sportType = '運動行為調查'
        }

        if (this.isDev == '1') {
            this.getListing();
        }

    },
    methods: {
        async initLIFF() {
            if (this.systemName == "recommend") {
                //運動建議
                this.myLiffId = '2002453331-wK4xYK9O';
            }
            await liff.init({ liffId: this.myLiffId });
        },
        async getLineUserID() {
            const self = this;
            if (this.systemName == "recommend") {
                //運動建議
                this.myLiffId = '2002453331-wK4xYK9O';
            }
            liff
                .init({
                    liffId: self.myLiffId
                })
                .then(() => {
                    if (liff.isLoggedIn()) {
                        const idtoken = liff.getIDToken();
                        console.log(idtoken)
                        const accessToken = liff.getAccessToken();
                        self.userToken = accessToken;
                        localStorage.setItem("userToken", accessToken);

                        self.userLoginType = localStorage.getItem("userLoginType");
                        // const googlecode = localStorage.getItem("googlecode");
                        let lineResult = localStorage.getItem("LIFF_STORE:2002453323-20Lo31Kp:decodedIDToken");
                        let lineaccessToken = localStorage.getItem("LIFF_STORE:2002453323-20Lo31Kp:accessToken");
                        if (self.systemName == "recommend") {
                            lineResult = localStorage.getItem("LIFF_STORE:2002453331-wK4xYK9O:decodedIDToken");
                            lineaccessToken = localStorage.getItem("LIFF_STORE:2002453331-wK4xYK9O:accessToken");
                        }

                        if (accessToken) {
                            try {
                                const lineObject = JSON.parse(lineResult);
                                self.userID = lineObject.sub;
                                self.userName = lineObject.name || "Unknown";
                                localStorage.setItem("lineObject", lineObject);
                                localStorage.setItem("linecode", lineObject.sub);
                                localStorage.setItem("linename", lineObject.name);
                                self.userToken = lineaccessToken;
                                self.userCode = lineObject.sub
                                self.getUser(lineObject.sub); 
                                // self.setUserDo(lineaccessToken);
                            } catch (error) {
                                console.log(error)
                            }
                        } else {
                            self.$router.push({ name: "LoginPage" });
                        }
                    } else {
                        self.$router.push({ name: "LoginPage" });
                    }
                })
                .catch((err) => {
                    alert('啟動失敗。' + err);
                });
        },
        getUser(x) {
            if (this.isDev == '1') {
                x = 'U2d06679ce81e3c95809062c2c48d517b';
            }
            const self = this;
            // 呼叫API獲取資料
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/getUser', {
                params: {
                    survey_type: self.systemName,
                    userId: x, // 這裡設置您的條件
                },
            })
                .then(response => {
                    console.log('getUser');
                    console.log(response.data);
                    if (response.data == "Account expired") {
                        self.$router.push({ path: "/accountValid" });
                    } 
                    else if (response.data) {
                        localStorage.setItem("userRole", response.data.userRole);
                        self.isVerify = true;
                        self.store.getUser();
                        self.userAccount = response.data.userAccount;
                        self.getListing(response.data.userRole,response.data.userAccount);
                    } else {
                        self.$router.push({ path: "/register" });
                    }
                })
                .catch(error => {
                    console.error('無法獲取資料：', error)
                })
        },
        getListing(r,u) {
            const self = this;
            // 呼叫API獲取資料
            let url='https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/get_my_data';
            if (this.store.user.userRole == 'admin' || r == 'admin' || this.isDev == '1'){
                url='https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/get_all_data';
            }
            axios.get(url, {
                params: {
                    sportType: self.sportType, // 這裡設置您的條件
                    userAccount: u
                },
            })
                .then(response => {
                    // 將API回傳的資料設定給tableData
                    //   this.tableData = response.data;
                    response.data.forEach(item => {
                        // 從每一筆資料中取出所需的欄位
                        const PK = item.PK;
                        const parts = item.PK.split("_");
                        const sportType = (parts[0] === 'behavior' ? '運動行為調查' : (parts[0] === 'recommend' ? '運動項目推薦' : '其他'));
                        const userid = parts[1];     // 取得"user123"

                        const SK = item.SK;
                        const user_login_type = item.user_login_type;

                        // 解析result_data欄位的JSON字串
                        const resultData = item.result_data;
                        // console.log(resultData)

                        // 取出result_data中的欄位
                        const intensity = resultData.intensity;
                        const habitstageValue = resultData.habitstageValue;
                        const activity = resultData.activity;
                        let answerDate = resultData.answerDate;
                        let name = resultData.name;
                        if (parts[0] === 'recommend') {
                            const formData = item.form_data;
                            name = formData.name;
                            answerDate = formData.answerDate;

                        }
                        // 將解析後的資料組成一個物件
                        const rowData = {
                            PK,
                            SK,
                            sportType,
                            userid,
                            user_login_type,
                            intensity,
                            habitstageValue,
                            activity,
                            answerDate,
                            name,
                        };

                        // 將rowData物件加入到this.tableData陣列中
                        this.tableData.push(rowData);
                    });
                })
                .catch(error => {
                    console.error('無法獲取資料：', error)
                })
        },
        setUserDo(x) {
            if (this.systemName == "recommend") {
                //運動建議
                this.lineLoginChannelID = '2002453331';
            }
            const url = "https://api.line.me/oauth2/v2.1/verify";
            const params = new URLSearchParams();
            params.append('id_token', x); // 確保 this.accessToken 包含有效的 id_token
            params.append('client_id', this.lineLoginChannelID);

            axios.post(url, params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then((response) => {
                    console.log('response')
                    console.log(response)
                    const data = response.data;
                    if (data.sub) {
                        this.isSuccess = true;
                        this.userID = data.sub;
                        this.userName = data.name || "Unknown";
                        localStorage.setItem("linedata", data);
                        localStorage.setItem("linesub", data.sub);
                        localStorage.setItem("linename", data.name);
                        // alert('Line登入成功');
                    }
                })
                .catch((error) => {
                    // 處理錯誤
                    console.error("Error:", error.response.data);
                    alert('Line登入失敗' + error.response.data);
                });
        },
        openPageDetail(PK, SK) {
            const parts = PK.split("_");
            if (parts[0] == 'recommend' || (this.systemName == "recommend" && parts[0] == 'aisports')) {
                this.$router.push({
                    path: '/detailpagerecommend',
                    query: {
                        PK: PK,
                        SK: SK,
                    }
                });

            } else {
                this.$router.push({
                    path: '/detailpage',
                    query: {
                        PK: PK,
                        SK: SK,
                    }
                });

            }



        },
        handleRowClick(item) {
            const PK = item.PK;
            const SK = item.SK;
            this.openPageDetail(PK, SK);
        },
        submitQuery() {
            const self = this;
            this.tableData = [];

            // 發送GET請求到後端API
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/search_data', {
                params: {
                    sportType: self.sportType, // 這裡設置您的條件
                    habitstageValue: self.habitstageValue,
                    intensity: self.intensity,
                    startDate: self.startDate,
                    endDate: self.endDate,
                    userRole: localStorage.getItem("userRole"),
                    userAccount: self.userAccount

                },
            })
                .then(response => {
                    // 成功取得資料
                    response.data.forEach(item => {
                        // 從每一筆資料中取出所需的欄位
                        const PK = item.PK;
                        const parts = item.PK.split("_");
                        const sportType = (parts[0] === 'behavior' ? '運動行為調查' : (parts[0] === 'recommend' ? '運動項目推薦' : '其他'));
                        // const userid = parts[1];     // 取得"user123"

                        const SK = item.SK;
                        const user_login_type = item.user_login_type;

                        // 解析result_data欄位的JSON字串
                        const resultData = item.result_data;
                        console.log(resultData)

                        // 取出result_data中的欄位
                        const intensity = resultData.intensity;
                        const habitstageValue = resultData.habitstageValue;
                        let answerDate = resultData.answerDate;
                        let name = resultData.name;
                        const activity = resultData.activity;
                        if (parts[0] === 'recommend') {
                            const formData = item.form_data;
                            name = formData.name;
                            answerDate = formData.answerDate;
                        }

                        // 將解析後的資料組成一個物件
                        const rowData = {
                            PK,
                            SK,
                            sportType,
                            // userid,
                            user_login_type,
                            intensity,
                            habitstageValue,
                            activity,
                            answerDate,
                            name,
                        };

                        // 將rowData物件加入到this.tableData陣列中
                        this.tableData.push(rowData);
                    });
                })
                .catch(error => {
                    // 處理錯誤
                    console.error('錯誤：', error);
                });
        },
        async downloadExcel() {
            try {
                const self = this;
                const response = await axios.post('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/downloadexcel', {
                    sportType: self.sportType, // 這裡放置您想傳遞的參數
                }, {
                    responseType: 'blob'
                });
                
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.xlsx');
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                console.error(error);
            }
        }
    }
}
</script>
<style scoped>
.table-container {
    margin: 20px 30px 30px 30px;
    /* 設置上下左右的邊距，你可以根據需要調整數值 */
}

.customize-table>table {
    width: 100% !important;
}

table[data-v-32683533] {
    width: 100% !important;
}


.table-container {
    /* background: #DFD6C8; */
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.table-container .row {
    margin-bottom: 10px;
}

.table-container .form-label {
    color: #616161;
    font-weight: bold;
    margin-bottom: 5px;
}

.table-container .form-control {
    border: 1px solid #A79B7E;
    background-color: #EFEDE1;
    color: #867A5C;
}

.table-container .form-control:focus {
    border-color: #D3A17E;
    box-shadow: 0 0 0 0.2rem rgba(211, 161, 126, 0.25);
}

.table-container .btn-primary {
    background-color: #CC785C;
    border-color: #D3A17E;
    color: #EFEDE1;
}

.table-container .btn-primary:hover {
    background-color: #D3A17E;
}

.table-container hr {
    border-top: 1px solid #A79B7E;
}

/* 整體背景與文字顏色 */
.table-container {
    /* background-color: #DFD6C8;  */
    color: #616161;
}

.form-label {
    color: #867A5C;
    /* 標籤文字使用較深的棕灰色 */
}

.form-control {
    background-color: #EFEDE1;
    /* 輸入框使用象牙色 */
    border: 1px solid #A79B7E;
    /* 邊框使用暖灰色 */
    color: #616161;
    /* 輸入文字使用深灰色 */
}

.form-control:focus {
    border-color: #CC785C;
    /* 輸入框聚焦時的邊框色 */
    box-shadow: 0 0 0 0.2rem rgba(205, 120, 92, 0.25);
    /* 聚焦時的陰影 */
}

.btn-primary {
    background-color: #CC785C;
    /* 按鈕使用銅紅色 */
    border-color: #D3A17E;
    /* 按鈕邊框使用淡粉棕色 */
    color: #EFEDE1;
    /* 按鈕文字使用象牙色 */
}

.btn-primary:hover {
    background-color: #D3A17E;
    /* 鼠標懸停時的按鈕背景色 */
    border-color: #CC785C;
    /* 鼠標懸停時的按鈕邊框色 */
}


.customize-table {

    --easy-table-border: 1px solid #DFD6C8;
    --easy-table-row-border: 1px solid #DFD6C8;

    --easy-table-header-font-size: 16px;
    --easy-table-header-height: 50px;
    --easy-table-header-font-color: #616161;
    /* 修改表頭字體顏色 */
    --easy-table-header-background-color: #DFD6C8;
    /* 修改表頭背景色 */

    --easy-table-header-item-padding: 10px 15px;

    --easy-table-body-even-row-font-color: #616161;
    /* 修改表體偶數行字體顏色 */
    --easy-table-body-even-row-background-color: #DFD6C8;
    /* 修改表體偶數行背景色 */

    --easy-table-body-row-font-color: #616161;
    /* 修改表體行字體顏色 */
    --easy-table-body-row-background-color: #EFEDE6;
    /* 修改表體行背景色 */
    --easy-table-body-row-height: 50px;
    --easy-table-body-row-font-size: 16px;

    --easy-table-body-row-hover-font-color: #616161;
    /* 修改表體行懸停字體顏色 */
    --easy-table-body-row-hover-background-color: #DFD6C8;
    /* 修改表體行懸停背景色 */
    --easy-table-body-item-padding: 10px 15px;

    --easy-table-footer-background-color: #EFEDE6;
    /* 修改表尾背景色 */
    --easy-table-footer-font-color: #616161;
    /* 修改表尾字體顏色 */
    --easy-table-footer-font-size: 16px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 50px;

    --easy-table-rows-per-page-selector-width: 70px;
    --easy-table-rows-per-page-selector-option-padding: 10px;
    --easy-table-rows-per-page-selector-z-index: 1;

    --easy-table-scrollbar-track-color: #445269;
    --easy-table-scrollbar-color: #445269;
    --easy-table-scrollbar-thumb-color: #4c5d7a;
    --easy-table-scrollbar-corner-color: #445269;

    --easy-table-loading-mask-background-color: #445269;
}</style>